import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import Footer from '../components/Footer'
import NewsCategories from '../components/NewsCategories'
import Menu from '../components/Menu'
import Link from '../components/IntlLink'
import PageAnimations from '../components/PageAnimations'
import Img from 'gatsby-image'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import { FormattedMessage } from 'react-intl'

class NewsIndex extends React.Component {
  constructor(props) {
    super(props)
  }

  renderNews(news, sectionAppears) {
    return (
      <Link to={`/news/${news.slug}#title`}
        className="news__half__item"
        style={{backgroundImage: `url(${news.cover.resize.src})`}}
        key={`${news.id}`}
      >
        <div className="news__half__container">
          <p className="page__text"> {news.date} </p>
          <h2 className="page__title"> {news.title} </h2>
        </div>
        <p className="page__text--abstract">
          {news.abstract}
        </p>
      </Link>
    )
  }

  render() {
    const { data, transition, pathContext } = this.props;
    const { data: { newsIndex: { title, slug } } } = this.props;
    const status = transition ? transition.status : "entering"
    const menuStyle = getTransitionStyle(status, 200, 2000, 'menuStyle')
    const timeout = 800
    const delay = 1000

    const sectionAppears = getTransitionStyle(
      status, timeout, 1000, 'pageAppearsFromBottom'
    )

    var allNews = data.news.edges.map((n) => n.node)

    if (pathContext.type === "category") {
      allNews = allNews.filter( news =>
        news.categories.map(c => c.slug).includes(pathContext.slug)
      )
    }

    if (pathContext.type === "tag") {
      allNews = allNews.filter( news =>
        news.newsTags.map(t => t.slug).includes(pathContext.slug)
      )
    }

    const allCategories = this.props.data.categories.edges.map((n) => n.node)

    return(
      <div
        className="page"
        style={{ backgroundColor: "#FFF" }}
      >
        <HelmetDatoCms
          seo={data.newsIndex.seo}
          favicon={data.site.favicon}
        />

        <Menu
          style={menuStyle}
          hasWhiteLogo={false}
          data={data}
        />

        <PageAnimations
          status={status}
          timeout={timeout}
          delay={timeout}
          color="#FFF"
        />

        <div className="page__wrapper" style={sectionAppears}>
          <h1 className="page__title--dark" >
            {
              pathContext.title ? pathContext.title : title
            }
          </h1>
          <div className="news__nav">
            <NewsCategories allCategories={allCategories}/>
          </div>
          <div className="wrap--large">
            {
              allNews.length > 0 ?
                <div className="news__half">
                  {
                    allNews.map(news => this.renderNews(news, sectionAppears))
                  }
                </div> :
                <div className="wrap">
                  <FormattedMessage
                    className="page__small-title--news"
                    style={sectionAppears}
                    id={`noContent`} />
                </div>
            }
          </div>
        </div>
        <Footer data={data} />
      </div>
    )
  }
}

export default NewsIndex
export const query = graphql`
  query NewsIndex($locale: String!) {
    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    newsIndex: datoCmsNewsHome(locale: { eq: $locale }) {
      themeColor {
        hex
      }
      title
      slug
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }

    news: allDatoCmsNews(filter: { locale: { eq: $locale } }, sort: { fields: [date], order: DESC } ) {
      edges {
        node {
          id
          title
          slug
          date
          abstract
          categories {
            slug
            title
          }
          newsTags {
            slug
            title
          }
          cover {
            resize(width: 800, imgixParams: { auto: "compress" }) {
              src
            }
          }
        }
      }
    }

    categories: allDatoCmsNewsCategory(filter: { locale: { eq: $locale } }) {
      edges {
        node {
          id
          title
          slug
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`



// WEBPACK FOOTER //
// ./src/templates/newsIndex.js